import { Modal } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../../Assets/svg";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { getItemSvg } from "../../../../../helpers/utils";

export enum ItemSVGs {
  MAST = "mast",
  DINGHY = "dinghy",
  EQUIPMENT = "equipment",
}

interface StoreItemOnMapProps {
  isOpen: boolean;
  onClose: () => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  item: ItemSVGs;
  itemToEdit?: any;
}

const StoreItemOnMap: React.FC<StoreItemOnMapProps> = ({ isOpen, onClose, setFieldValue, itemToEdit, item }) => {
  const [itemToAdd, setItemToAdd] = useState(
    itemToEdit
      ? {
          id: itemToEdit?._id,
          position: {
            lat: itemToEdit?.location_in_yard?.lat,
            lng: itemToEdit?.location_in_yard?.long,
          },
          size: itemToEdit?.location_in_yard?.size,
          rotation: itemToEdit?.location_in_yard?.angle,
          color: "#CD9E13",
        }
      : null
  );

  const handleMapClick = (e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      const newMarker = {
        id: `${Date.now()}`,
        position: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        },
        size: 50,
        rotation: 0,
        color: "#CD9E13",
      };
      setItemToAdd(newMarker);
    }
  };

  const handleDragEnd = (id: string, e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      setItemToAdd((prev) => ({
        ...prev,
        position: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        },
      }));
    }
  };
  return (
    <Modal
      title={<div className="modal-header border-bottom pb-2 fw-bold fs-4">Manage Location </div>}
      open={isOpen}
      onCancel={onClose}
      width="67.5rem"
      closeIcon={svg.modalClose}
      centered
      destroyOnClose
      footer={
        itemToAdd ? (
          <div className="row mb-3 align-items-center">
            <div className="col-sm-5 col-6">
              <label className="custom-label mb-1 ff d-block text-start">Rotate</label>
              <input
                className="w-100 form-range"
                defaultValue={0}
                type="range"
                min={0}
                max={360}
                value={itemToAdd.rotation}
                onChange={(e) => setItemToAdd((prev) => ({ ...prev, rotation: Number(e.target.value) }))}
              />
            </div>

            <div className="col-sm-5 col-6">
              <label className="custom-label mb-1 ff d-block text-start">Resize</label>
              <input
                type="range"
                className="w-100 form-range"
                defaultValue={50}
                min={10}
                max={100}
                value={itemToAdd.size}
                onChange={(e) => setItemToAdd((prev) => ({ ...prev, size: Number(e.target.value) }))}
              />
            </div>

            <div className="col-sm-auto text-end">
              <button
                className="btn btn-primary btn-lg w-100"
                onClick={() => {
                  setFieldValue("selectedLatLang.latitude", itemToAdd.position.lat);
                  setFieldValue("selectedLatLang.longitude", itemToAdd.position.lng);
                  setFieldValue("selectedRoatation", itemToAdd.rotation);
                  setFieldValue("selectedSize", itemToAdd.size);
                  onClose();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        ) : (
          <></>
        )
      }
      className="custom-modal"
      style={{ padding: 0 }}
    >
      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "700px",
        }}
        center={{
          lat: 44.165597,
          lng: -69.161784,
        }}
        zoom={18}
        options={{
          gestureHandling: "none",
          mapTypeId: "satellite",
          disableDefaultUI: true,
          draggable: false,
        }}
        onClick={handleMapClick}
      >
        {itemToAdd && (
          <Marker
            key={itemToAdd.id}
            position={itemToAdd.position}
            draggable={true}
            icon={{
              url: getItemSvg(item, itemToAdd.size, itemToAdd.rotation),
              scaledSize: new google.maps.Size(itemToAdd.size, itemToAdd.size),
              anchor: new google.maps.Point(itemToAdd.size / 2, itemToAdd.size / 2),
            }}
            onDragEnd={(e) => handleDragEnd(itemToAdd.id, e)}
            // onClick={() => handleSelectBoat(boatToAdd.id)}
          />
        )}
      </GoogleMap>
    </Modal>
  );
};

export default StoreItemOnMap;
